import { getIframeForCoreApi } from 'helpers/browser';
import {
  KustomerMainWindow,
  KustomerMainMethods,
  KustomerMain,
} from 'core/types';

type RunMainMethodParams<M extends KustomerMainMethods> = Parameters<
  KustomerMain[M]
>;

// eslint-disable-next-line import/prefer-default-export
export const runMainMethod = <M extends KustomerMainMethods>(
  method: M,
  ...params: RunMainMethodParams<M>
): ReturnType<KustomerMain[M]> | undefined => {
  const iframe = getIframeForCoreApi();

  if (!iframe || !iframe.contentWindow) return undefined;

  const kustomerMainWindow: KustomerMainWindow = iframe.contentWindow;

  const kustomerMain = kustomerMainWindow?.KustomerMain;

  if (!kustomerMainWindow || !kustomerMain || !kustomerMain[method])
    return undefined;

  if (!kustomerMain[method]) return undefined;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return kustomerMain[method](...params);
};
